

const styles = (theme) => ({
    outerBox: {
        width: "100%"
    },
    innerBox: {
        width: "70%",
        marginLeft: "auto",
        marginRight: "auto"
    },
    section: {
        marginTop: "1em",
        marginBottom: "1em",
        padding: "2em"
    },
    longSection: {
        paddingTop: "2em",
        paddingBottom: "2em"
    },
    greySection: {
        backgroundColor: "#f6f6f6"
    },
    // popup:{
    //     marginLeft: "auto",
    //     marginRight: "auto",
    //     // position: 'absolute',/
    //     width: theme.spacing.unit * 75,
    //     height: theme.spacing.unit * 75,
    //     backgroundColor: "white",
    //     boxShadow: theme.shadows[5],
    //     padding: theme.spacing.unit * 4,
    // },
    subscribe: {
        backgroundColor: "white",
        marginLeft: "auto",
        marginRight: "auto",
        padding: "1em"
    },
    innerHeaderSection: {
        paddingTop: "2em",
        padding: "5px",
        paddingBottom: "2em",
        textAlign: "center",
    },
    innerDetailSection: {

    },
    centered: {
        textAlign: "center",
    },

    captials: {
        textTransform: "uppercase"
    },
    videoRootContainer: {
        width: "100%",
        height: "40em",
        position: "relative",
        overflow: "hidden"
    },
    videoContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    videoMessageContainer: {
        width: "100%",
        height: "100%",
        position: "absolute",
        display: "flex",
        background: "rgba(0,0,0,0.4)",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left: 0,
        color: "#fff",
    },
    companyTitle: {
        color: "#fff",
        fontFamily: 'Grand Hotel',
        fontSize: "80px",
        letterSpacing: ".02em",
        ['@media screen and (max-width: 600px)']: { // eslint-disable-line no-useless-computed-key
            fontSize: '20px'
        }
    },
    companyMoto: {
        color: "#fff",
        fontFamily: 'Roboto',
        letterSpacing: ".1em",
        marginBottom: "5vw"
    },
    centerImage: {
        textAlign: "center",
        marginBottom: "2em",
        width: "100%",
        height: "auto"
    },

    //About Us
    aboutUsIcon: {
        width: "100px",
        height: "auto",
        margin: "10px",
        padding: "30px",
        border: "solid 1px #d3dee3",
        borderRadius: "4px"
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        marginBottom: "2em"
    },
    gridList: {
        flexWrap: "nowrap",
        width: "100%",
        height: "180px",
        transform: 'translateZ(0)',
        marginBottom: "1em"
    },
    gridListTile: {
        height: "100%",
        width: "360px",
        borderRadius: "4px",
        backgroundColor: "#ffffff",
        // border: "solid 1px #d3dee3",
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    projectImageContainer: {
        height: "400px",
        maxHeight: "400px",
        borderRadius: "4px",
        backgroundColor: "#efefef",
        display: "flex",
        flexDirection: 'row',
        justifyContent: "center",
        textAlign: "center",
        alginItem: "center",
        ['@media screen and (max-width: 600px)']: { // eslint-disable-line no-useless-computed-key
            height: "100%",
        },
        // padding: "1em"
    },
    projectImage: {
        height: "auto",
        width: "100%",
        objectFit: "contain"
    },
    spyProjectImage: {
        height: "auto",
        width: "30%",
        objectFit: "contain"
    },

    projectDescription: {
        height: "100%",
        display: "flex",
        padding: "0",
        paddingLeft: "2em",
        flexDirection: "column",
        ['@media screen and (max-width: 600px)']: { // eslint-disable-line no-useless-computed-key
            paddingTop: "2em",
            paddingLeft: "0"
        },
    },
    projectDescriptionName: {
        fontSize: 35,
        marginTop: 20,
        marginBottom: 10,
        flexBasis: "26%",
        color: 'rgba(0,0,0,0.5)',
        ['@media screen and (max-width: 1024px) and (min-width:768px)']: { // eslint-disable-line no-useless-computed-key
            fontSize: 30,
        },
    },
    inventoryContainer: {
        display: "flex",
        justifyContent: "center",
        borderRadius: "4px",
        padding: "1em",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    inventoryItem: {
        width: "150px",
        height: "150px",
        textAlign: "center",
        alignItems: "center",
        backgroundColor: "#ffffff",
        border: "solid 1px #d3dee3",
        margin: "10px",
        padding: "1em",
        display: "flex",
        flexDirection: "column"
    },
    inventoryIconContainer: {
        flexBasis: "80%",
        justifyContent: "center",
        alignSelf: "center",
        // display:table-cell;
        verticalAlign: "middle",
        textAlign: "center",
    },
    inventoryIcon: {
        width: "100px"
    },
    newsletterInput: {
        width: "100%",
        height: "47px",
        // opacity: 0.05,
        border: "solid 1px #d3dee3",
        borderRadius: "4px 0 0 4px",
        color: "black",
        paddingLeft: 15
    },
    newsletterButton: {
        height: "50px",
        borderRadius: "0 4px 4px 0",
        marginLeft: "-2px",
        marginTop: "-2px"
    },
    contactUsContainer: {
        justifyContent: "space-between",
        padding: "2em",

    },
    itemLink: {
        textDecoration: "none",
        color: "rgba(0, 0, 0, 0.54)",
    },
    socialIcons: {
        width: "40px",
        height: "auto"
    },
    articles: {
        marginTop: 80,
        width: '40%',
        margin: 'auto',
        padding: 20,
        ['@media screen and (max-width: 600px)']: { // eslint-disable-line no-useless-computed-key
            width: '70%'
        },
        backgroundColor: "#f6f6f6"
    },
    subscribeInput: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '50%',
        margin: 'auto',
        ['@media screen and (max-width: 600px)']: { // eslint-disable-line no-useless-computed-key
            width: '85%'
        }

    }

});

export default styles;